import PalTooltip from "~components/mui/PalTooltip";

const PRTooltip = PalTooltip;

export default PRTooltip;
